var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "my-input",
      class: {
        "is-focus ": _vm.showFocusMode,
        " input-group ": _vm.hasAppendSlot
      }
    },
    [
      _vm.type === "checkbox"
        ? _c(
            "input",
            _vm._g(
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.current_value,
                    expression: "current_value"
                  }
                ],
                ref: "input",
                staticClass: "form-control",
                class: _vm.additionalClass,
                attrs: {
                  name: _vm.name,
                  placeholder: _vm.current_placeholder,
                  disabled: _vm.disabled,
                  readonly: _vm.readonly,
                  maxlength: _vm.maxlength,
                  max: _vm.max,
                  min: _vm.min,
                  autocomplete: _vm.autocomplete_value,
                  type: "checkbox"
                },
                domProps: {
                  checked: Array.isArray(_vm.current_value)
                    ? _vm._i(_vm.current_value, null) > -1
                    : _vm.current_value
                },
                on: {
                  input: _vm.onInput,
                  focus: _vm.onFocus,
                  blur: _vm.onBlur,
                  change: function($event) {
                    var $$a = _vm.current_value,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.current_value = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.current_value = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.current_value = $$c
                    }
                  }
                }
              },
              _vm.listeners
            )
          )
        : _vm.type === "radio"
        ? _c(
            "input",
            _vm._g(
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.current_value,
                    expression: "current_value"
                  }
                ],
                ref: "input",
                staticClass: "form-control",
                class: _vm.additionalClass,
                attrs: {
                  name: _vm.name,
                  placeholder: _vm.current_placeholder,
                  disabled: _vm.disabled,
                  readonly: _vm.readonly,
                  maxlength: _vm.maxlength,
                  max: _vm.max,
                  min: _vm.min,
                  autocomplete: _vm.autocomplete_value,
                  type: "radio"
                },
                domProps: { checked: _vm._q(_vm.current_value, null) },
                on: {
                  input: _vm.onInput,
                  focus: _vm.onFocus,
                  blur: _vm.onBlur,
                  change: function($event) {
                    _vm.current_value = null
                  }
                }
              },
              _vm.listeners
            )
          )
        : _c(
            "input",
            _vm._g(
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.current_value,
                    expression: "current_value"
                  }
                ],
                ref: "input",
                staticClass: "form-control",
                class: _vm.additionalClass,
                attrs: {
                  name: _vm.name,
                  placeholder: _vm.current_placeholder,
                  disabled: _vm.disabled,
                  readonly: _vm.readonly,
                  maxlength: _vm.maxlength,
                  max: _vm.max,
                  min: _vm.min,
                  autocomplete: _vm.autocomplete_value,
                  type: _vm.type
                },
                domProps: { value: _vm.current_value },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.current_value = $event.target.value
                    },
                    _vm.onInput
                  ],
                  focus: _vm.onFocus,
                  blur: _vm.onBlur
                }
              },
              _vm.listeners
            )
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasAppendSlot,
              expression: "hasAppendSlot"
            }
          ],
          staticClass: "input-group-append"
        },
        [_c("span", { staticClass: "input-group-text" }, [_vm._t("append")], 2)]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "my-input-label",
          on: {
            click: function($event) {
              return _vm.$refs.input.focus()
            }
          }
        },
        [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }